import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

import { uiBackgroundColor } from "@/view/utils/userContentUIStyles/userContentUIStyles.style";

const { mediaQuery } = mediaQueryStyles;
const { colors, breakpoints } = constants;
const { sm, md } = breakpoints.BreakpointNames;

const { fontSize } = typographyStyles;

export const innerContainerCss = (uiType) => ({
  borderRadius: "0 85px 0 0",
  marginBottom: "24px",
  width: "100%",

  [mediaQuery.downTo(sm)]: {
    borderRadius: "0 100px 0 0",
  },

  "&:before, &:after": {
    content: '""',
    backgroundColor: uiBackgroundColor(uiType),
    zIndex: -1,
    height: "33%",
    position: "absolute",
    top: 0,
    width: "100vw",

    [mediaQuery.upTo(sm)]: {
      height: "28%",
    },

    [mediaQuery.between(sm, md)]: {
      height: "25%",
    },
  },
  "&:before": {
    // Positioning:
    // The background is the full width of the viewport and half the height of the image.
    // Because the height is relative to the image, the left position is relative to the leftmost point of the image.
    // In order to move it to the left edge of the viewport, we need to move it left by half of the viewport width and right by half of the image width.
    left: "calc(-50vw + 50%)",
  },
  "&:after": {
    // Positioning:
    // When the activity panel is open, we remove the overflow on the article content and add the bg to the right side
    // This will help avoid to much extra space and have a unnecessary scrollbar.
    right: "-50vw",
  },
});

export const captionCss = [
  fontSize.textXS,
  {
    color: colors.ui.neutral[400],
    paddingTop: "1.2rem",
  },
];

export const figureCss = {
  margin: "0",
};
